import ModalBorder from './ModalBorder.view';

export default ModalBorder;
